const TruckUnLoadDeportIcon = ({ color = '#000', width = 24 }) => {
    return (
        <svg 
            id="Layer_1" 
            data-name="Layer 1" 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 59.9 52" 
            width={width} 
            height={width} 
            style={{ verticalAlign: 'middle' }}
        >
            <path 
                fill={color} 
                className="cls-1" 
                d="M10.4,17.7v-5.9h13.2c1.1,0,2-.9,2-2s-.9-2-2-2h-13.3V1.9c0-1.2-.7-1.5-1.5-.6L.4,9.9l8.4,8.6c.8.8,1.5.6,1.5-.6v-.2s.1,0,.1,0Z"
            />
            <path 
                fill="none" 
                className="cls-2" 
                d="M51.6,41c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6,3.6-1.6,3.6-3.6-1.6-3.6-3.6-3.6Z"
            />
            <path 
                fill="none" 
                className="cls-2" 
                d="M37,41.7h-.8v-4.9h4v-1.1h-5.4c-.2,2.5-.9,4.8-2,6.9l4.1-.9h.1Z"
            />
            <path 
                fill={color} 
                className="cls-1" 
                d="M59.3,36.8h-2.7c-1-.6-2.1-.9-3.5-1.1h6.2v-1.5h-24.5v1.5h5.4v1.1h-4v4.9h.8l-4.1.9c-.4.8-.9,1.5-1.4,2.2l6.9-1.6h4.4v2.1h1.7c0,1.7.9,3.3,2.1,4.5,1.4,1.4,3.3,2.2,5.3,2.2s3.9-.9,5.2-2.2c1.1-1.2,1.9-2.7,2.1-4.5h.4v-8.5s-.3,0-.3,0ZM51.6,48.2c-2,0-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6,3.6,1.6,3.6,3.6-1.6,3.6-3.6,3.6Z"
            />
            <path 
                fill={color} 
                className="cls-1" 
                d="M30.6,3.4h28.7V0H27.3v20.4c.5.3,3,2.7,3.4,3V3.4h0Z"
            />
            <path 
                fill={color} 
                className="cls-1" 
                d="M13.9,42.4l10.6-10.6-2.3-2.3-8.3,8.3-4.1-4.1-2.3,2.3s6.4,6.4,6.4,6.4ZM16,50.6c-2.1,0-4.1-.4-5.9-1.2-1.8-.8-3.4-1.9-4.8-3.2-1.4-1.4-2.4-3-3.2-4.8s-1.2-3.8-1.2-5.9.4-4.1,1.2-5.9c.8-1.8,1.9-3.4,3.2-4.8,1.4-1.4,3-2.4,4.8-3.2,1.8-.8,3.8-1.2,5.9-1.2s4.1.4,5.9,1.2c1.8.8,3.4,1.9,4.8,3.2,1.4,1.4,2.4,3,3.2,4.8.8,1.8,1.2,3.8,1.2,5.9s-.4,4.1-1.2,5.9c-.8,1.8-1.9,3.4-3.2,4.8-1.4,1.4-3,2.4-4.8,3.2s-3.8,1.2-5.9,1.2Z"
            />
        </svg>
    );
};

export default TruckUnLoadDeportIcon;
